/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_UpdatingInputs */

const en_shared_updating = /** @type {(inputs: Shared_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating…`)
};

const nl_shared_updating = /** @type {(inputs: Shared_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bijwerken…`)
};

/** @type {(inputs: Shared_UpdatingInputs) => LocalizedString} */
const de_shared_updating = en_shared_updating;

/** @type {(inputs: Shared_UpdatingInputs) => LocalizedString} */
const es_shared_updating = en_shared_updating;

/** @type {(inputs: Shared_UpdatingInputs) => LocalizedString} */
const fr_shared_updating = en_shared_updating;

/** @type {(inputs: Shared_UpdatingInputs) => LocalizedString} */
const it_shared_updating = en_shared_updating;

/** @type {(inputs: Shared_UpdatingInputs) => LocalizedString} */
const pt_br2_shared_updating = en_shared_updating;

/** @type {(inputs: Shared_UpdatingInputs) => LocalizedString} */
const pl_shared_updating = en_shared_updating;

/** @type {(inputs: Shared_UpdatingInputs) => LocalizedString} */
const hu_shared_updating = en_shared_updating;

/** @type {(inputs: Shared_UpdatingInputs) => LocalizedString} */
const ro_shared_updating = en_shared_updating;

/**
* | output |
* | --- |
* | "Updating…" |
*
* @param {Shared_UpdatingInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_updating = /** @type {((inputs?: Shared_UpdatingInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_UpdatingInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_updating(inputs)
	if (locale === "de") return de_shared_updating(inputs)
	if (locale === "es") return es_shared_updating(inputs)
	if (locale === "fr") return fr_shared_updating(inputs)
	if (locale === "nl") return nl_shared_updating(inputs)
	if (locale === "it") return it_shared_updating(inputs)
	if (locale === "pt-BR") return pt_br2_shared_updating(inputs)
	if (locale === "pl") return pl_shared_updating(inputs)
	if (locale === "hu") return hu_shared_updating(inputs)
	return ro_shared_updating(inputs)
});
export { shared_updating as "shared.updating" }